import React, { useEffect, useState, useRef } from 'react';

import { MapContainer, TileLayer, LayersControl, useMap, GeoJSON } from 'react-leaflet';

import './map.scss';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import 'leaflet-sleep';
import FullscreenControl from './components/fullScreenControl';
import { leafletAttribution } from './helper';

//CUSTOM LEAFLET FIXES

const DefaultIcon = L.icon({
  iconUrl: icon,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  shadowAnchor: [4, 62],
  popupAnchor: [-3, -76],
});

L.Marker.prototype.options.icon = DefaultIcon;

const ReadOnlyMap = ({ geometry, extent, geometryName = 'Project Location', height = '60vh' }) => {
  const zoom = 4;
  const center = [37.612345, -95.661234];
  const readOnlyMapRef = useRef();
  const layersControlRef = useRef();

  const PanToExtent = () => {
    const map = useMap();

    useEffect(() => {
      map?.invalidateSize();
      if (extent?.length > 0) {
        map?.fitBounds(extent);
      }
    }, [map]);

    return null;
  };

  const MyGeoJSONData = () => {
    const [data, setData] = useState();

    useEffect(() => {
      geometry && setData(geometry);
    }, []);

    return data ? (
      <GeoJSON
        data={data}
        onEachFeature={(feature, layer) => {
          layer.bindTooltip(geometryName, {
            direction: 'right',
            permanent: false,
            sticky: true,
            offset: [10, 0],
            opacity: 0.75,
          });
        }}
      />
    ) : null;
  };

  //Fix to leaflet rendering bug
  const RefreshMap = () => {
    const map = useMap();
    useEffect(() => {
      map.attributionControl.setPrefix(leafletAttribution);
      map.invalidateSize();
    }, [map]);

    return null;
  };

  return (
    <>
      <div style={{ display: 'flex', height: height, minHeight: '200px' }}>
        <MapContainer
          style={{ flex: 1, width: '100%' }}
          center={center}
          zoom={zoom}
          sleepNote={false}
          hoverToWake={false}
          ref={readOnlyMapRef}
          sleepOpacity={1}
          worldCopyJump={true}
        >
          <FullscreenControl />
          <PanToExtent />
          <LayersControl ref={layersControlRef} position='bottomright'>
            <LayersControl.BaseLayer checked name='OSM Streets'>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name='ESRI World Imagery'>
              <TileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name='USGS World Imagery (zoom limit)'>
              <TileLayer
                attribution='Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'
                url='https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}'
                maxZoom={16}
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name='USGS Topographic (zoom limit)'>
              <TileLayer
                attribution='Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'
                url='https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}'
                maxZoom={16}
              />
            </LayersControl.BaseLayer>
            <MyGeoJSONData />
          </LayersControl>
          <RefreshMap />
        </MapContainer>
      </div>
    </>
  );
};

export default ReadOnlyMap;
